import { defineCopy } from '@/copy';

/** platform strings. Keep the voice: short, funny, no em dashes. */
export const copy = defineCopy('platform', {
  devices: {
    title: 'Your phones',
    line: 'One phone, one login. Lose it and a crewmate gets you back in.',
    loading: 'Counting phones...',
    failed: "Couldn't load your phones. Pull up the app again with some signal.",
    thisPhone: 'This phone',
    newToday: 'New today',
    newLine: 'Not you? Sign it out.',
    seen: 'Seen {ago}',
    added: 'Added {ago}',
    signOut: 'Sign out',
    signOutTitle: 'Sign out {name}?',
    signOutBody: 'That phone drops back to the Welcome screen. Anything it had not synced stays on it.',
    signOutConfirm: 'Sign it out',
    cancel: 'Keep it',
    signedOut: 'Signed out.',
    signOutFailed: "That didn't work. Try again.",
    unnamed: 'A phone',
    justNow: 'just now',
    minutes: '{n} min ago',
    hours: '{n} h ago',
    yesterday: 'yesterday',
    days: '{n} days ago',
    platforms: {
      ios: 'iPhone or iPad',
      android: 'Android phone',
      desktop: 'Computer',
      other: 'Phone',
    },
  },
});
